import { Component, Input, OnInit } from '@angular/core'
import { ExamsService } from '../../../services/exams/exams.service'

@Component({
	selector: 'app-upload-file-patient',
	templateUrl: './upload-file-patient.component.html',
	styleUrls: ['./upload-file-patient.component.scss'],
})
export class UploadFilePatient implements OnInit {
	@Input() pathExams?: string
	@Input() title: string = ''

	constructor(private examsService: ExamsService) {}

	ngOnInit(): void {}

	downloadFile() {
		if (this.pathExams) {
			this.examsService
				.getFile(this.pathExams)
				.then((data) => {
					console.log('this.blob', data)
					this.downloadBlob(data)
				})
				.catch((error) => {})
		}
	}

	downloadBlob(blob: Blob) {
		const url = window.URL.createObjectURL(blob)
		const a = document.createElement('a')
		a.href = url
		a.download = this.title
		a.click()
		window.URL.revokeObjectURL(url)
	}
}
